/* global __DivvyEnvironment */

import { logError, logInfo } from './../utils/loggerUtils'

const PERSONA_ENV = __DivvyEnvironment.PERSONA_ENV || 'sandbox'

export class PersonaClient {
  constructor(inquiryId, refetch) {
    this.inquiryId = inquiryId
    this.refetch = refetch
  }

  async open() {
    const { default: Persona } = await import(/* webpackChunkName: "persona-sdk" */ 'persona')
    const { inquiryId, refetch } = this

    this.client = new Persona.Client({
      environment: PERSONA_ENV,
      inquiryId,
      onCancel: ({ inquiryId }) =>
        logInfo('personaQueryCancelled', {
          attributes: {
            inquiryId,
            result: `${inquiryId} exit`,
          },
          eventName: 'PersonVerification',
        }),
      onComplete: ({ inquiryId, status }) => {
        logInfo('personaQueryComplete', {
          attributes: {
            inquiryId,
            result: `${inquiryId} ${status}`,
          },
          eventName: 'PersonVerification',
        })
        // when complete refetch GetApplicationStatuses
        refetch()
      },
      onError: (error) =>
        logError(error, {
          attributes: {
            action: 'personalQueryError',
            inquiryId,
            result: `${error.status} — ${error.code}`,
          },
          eventName: 'PersonVerification',
        }),
    })

    this.client.open()
  }
}
